import { Fragment } from 'react';
import { Box, Modal } from '@mui/material';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { RootState, useAppDispatch } from 'redux/store';
import { setEndQuiz } from 'redux/quiz_manager/quizSlice';
import { useMutation } from '@apollo/client';
import { Spinner } from 'react-bootstrap';
import { SKIP_ALL_QUIZZES } from 'graph_ql/getQuiz/mutation';
import { TRACK_EVENT, trackEvent } from 'utils/analytics';
import { STRINGS } from '../../constants/strings';
import { useSelector } from 'react-redux';
enum globalQuizEventType {
    SKIPPED = 'skipped',
    RESUMED = 'resumed',
}
const useStyles = makeStyles(() => ({
    container: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 'calc(100% - 48px)',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        padding: 24,
        borderRadius: 16,
        backgroundColor: 'white',
        outline: 'none',
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    titleContent: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        fontFamily: 'Fraunces',
        fontWeight: 400,
        fontSize: '18px',
        color: '#1A1A1A',
        textAlign: 'center',
    },
    bodyContent: {
        margin: '30px 0px',
        textAlign: 'center',
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '14px',
        color: '#1A1A1A',
    },
    image: {
        width: '100%',
        height: 'auto',
    },
    footerContainer: {},
    footerButton: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px',
        border: '1px solid #1A1A1A',
        borderRadius: '42px',
    },
    footerButtonText: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '14px',
        color: '#1A1A1A',
    },
}));

export const QuizSkipModal = ({ data, visible, onHide }) => {
    const styles = useStyles();
    const [isSkipConfirmation, setIsSkipConfirmation] = useState(false);
    const dispatch = useAppDispatch();
    const me = useSelector((state: RootState) => state.userDetail.me);
    const trackSkipQuiz = (type) => {
        trackEvent(TRACK_EVENT.USER_QUIZ_GLOBAL_SKIP_CLICKED, {
            userId: me?.id,
            userType: me?.userType,
            email: me?.email,
            type,
            quizId: data?.quizId,
        });
    };
    const onSkipAllQuizCompleted = () => {
        trackSkipQuiz(globalQuizEventType.SKIPPED);
        setIsSkipConfirmation(true);
    };

    const [answersMutation, { loading: loadingAnswer }] = useMutation(SKIP_ALL_QUIZZES, {
        onCompleted() {
            onSkipAllQuizCompleted();
        },
        onError(error) {
            console.error('Create Failed: ', error);
        },
    });

    const handleSkipQuiz = () => {
        const variables = {
            input: {
                currentQuizId: data?.quizId,
            },
        };
        answersMutation({ variables });
    };

    const handleClose = () => {
        trackSkipQuiz(globalQuizEventType.RESUMED);
        onHide();
        if (isSkipConfirmation) {
            skipQuiz();
        }
    };

    const skipQuiz = () => {
        onHide();
        setIsSkipConfirmation(false);
        dispatch(setEndQuiz(true));
    };

    const isClickAllowed = (func) => {
        if (!loadingAnswer) func();
    };

    return (
        <Modal open={visible}>
            <Box className={styles.container}>
                {!isSkipConfirmation ? (
                    <Fragment key={'confirmationPopup'}>
                        <div className={styles.titleContainer}>
                            <div className={styles.titleContent}>Skip Style Profile Discovery ?</div>
                        </div>
                        <div className={styles.bodyContent}>
                            We highly recommend completing your style profile now to receive a truly personalized
                            styling experience. <br />
                            <br />
                            Are you sure you want to skip discovering your style profile?
                        </div>
                        <div className={styles.footerContainer}>
                            <div className={styles.footerButton} onClick={() => isClickAllowed(handleSkipQuiz)}>
                                Yes, Skip Now
                                {loadingAnswer && (
                                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                )}
                            </div>
                            <div
                                className={styles.footerButton}
                                style={{ marginTop: '10px' }}
                                onClick={() => isClickAllowed(handleClose)}
                            >
                                No, Continue Discovery
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <>
                        <div className={styles.titleContainer}>
                            <div className={styles.titleContent}>Style Profile Discovery Skipped</div>
                        </div>
                        <div className={styles.bodyContent}>
                            You've skipped the style profile discovery. Don't worry, you can set it up anytime from your{' '}
                            <span style={{ fontWeight: '600' }}>Profile {'>'} My Style Preferences</span> settings to
                            receive personalized styling experience.
                        </div>
                        <div className={styles.footerContainer}>
                            <div className={styles.footerButton} onClick={skipQuiz}>
                                {STRINGS.OKAY}
                            </div>
                        </div>
                    </>
                )}
                {/* <CloseIcon
                    name="quiz-help-close-btn"
                    width={24}
                    htmlColor="black"
                    onClick={onHide}
                /> */}
            </Box>
        </Modal>
    );
};
